import { render, staticRenderFns } from "./CoresCurvas.vue?vue&type=template&id=2529908b&scoped=true"
import script from "./CoresCurvas.vue?vue&type=script&lang=js"
export * from "./CoresCurvas.vue?vue&type=script&lang=js"
import style0 from "./CoresCurvas.vue?vue&type=style&index=0&id=2529908b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2529908b",
  null
  
)

export default component.exports